/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.playlists.rpc.LearningPathChirpService
 */
import * as References from './LearningPathChirpService';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.playlists.rpc.LearningPathChirpService#get
 */
export const GET_QUERY_FIELD_NAME = 'com_hubspot_learning_center_playlists_rpc_LearningPathChirpService_get';
export const GET_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_QUERY_FIELD_NAME,
  args: ['playlistId'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.playlists.rpc.LearningPathChirpService#getPlaylistOrLearningPath
 */
export const GET_PLAYLIST_OR_LEARNING_PATH_QUERY_FIELD_NAME = 'com_hubspot_learning_center_playlists_rpc_LearningPathChirpService_getPlaylistOrLearningPath';
export const GET_PLAYLIST_OR_LEARNING_PATH_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PLAYLIST_OR_LEARNING_PATH_QUERY_FIELD_NAME,
  args: ['playlistId'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getPlaylistOrLearningPathRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.playlists.rpc.LearningPathChirpService#getPlaylistsOrLearningPaths
 */
export const GET_PLAYLISTS_OR_LEARNING_PATHS_QUERY_FIELD_NAME = 'com_hubspot_learning_center_playlists_rpc_LearningPathChirpService_getPlaylistsOrLearningPaths';
export const GET_PLAYLISTS_OR_LEARNING_PATHS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PLAYLISTS_OR_LEARNING_PATHS_QUERY_FIELD_NAME,
  args: ['playlistIds'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getPlaylistsOrLearningPathsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.playlists.rpc.LearningPathChirpService#getAllPaginated
 */
export const GET_ALL_PAGINATED_QUERY_FIELD_NAME = 'com_hubspot_learning_center_playlists_rpc_LearningPathChirpService_getAllPaginated';
export const GET_ALL_PAGINATED_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_ALL_PAGINATED_QUERY_FIELD_NAME,
  args: ['pageLength', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.getAllPaginatedRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.playlists.rpc.LearningPathChirpService#getLearningPaths
 */
export const GET_LEARNING_PATHS_QUERY_FIELD_NAME = 'com_hubspot_learning_center_playlists_rpc_LearningPathChirpService_getLearningPaths';
export const GET_LEARNING_PATHS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_LEARNING_PATHS_QUERY_FIELD_NAME,
  args: ['learningPathIds'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.getLearningPathsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.playlists.rpc.LearningPathChirpService#getSimpleLearningPathsOrPlaylists
 */
export const GET_SIMPLE_LEARNING_PATHS_OR_PLAYLISTS_QUERY_FIELD_NAME = 'com_hubspot_learning_center_playlists_rpc_LearningPathChirpService_getSimpleLearningPathsOrPlaylists';
export const GET_SIMPLE_LEARNING_PATHS_OR_PLAYLISTS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_SIMPLE_LEARNING_PATHS_OR_PLAYLISTS_QUERY_FIELD_NAME,
  args: ['playlistIds'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.getSimpleLearningPathsOrPlaylistsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.playlists.rpc.LearningPathChirpService#getAllPaginatedInternal
 */
export const GET_ALL_PAGINATED_INTERNAL_QUERY_FIELD_NAME = 'com_hubspot_learning_center_playlists_rpc_LearningPathChirpService_getAllPaginatedInternal';
export const GET_ALL_PAGINATED_INTERNAL_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_ALL_PAGINATED_INTERNAL_QUERY_FIELD_NAME,
  args: ['pageLength', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient7;
    return ((_ctx$customClient7 = ctx.customClient) !== null && _ctx$customClient7 !== void 0 ? _ctx$customClient7 : chirpClient).call(References.getAllPaginatedInternalRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.playlists.rpc.LearningPathChirpService#create
 */
export const CREATE_MUTATION_FIELD_NAME = 'com_hubspot_learning_center_playlists_rpc_LearningPathChirpService_create';
export const CREATE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_MUTATION_FIELD_NAME,
  args: ['name', 'description', 'thumbnailRectangleUrl', 'thumbnailSquareUrl', 'internalName', 'visibility', 'difficulty', 'active', 'items', 'language'],
  fetcher(request, ctx) {
    var _ctx$customClient8;
    return ((_ctx$customClient8 = ctx.customClient) !== null && _ctx$customClient8 !== void 0 ? _ctx$customClient8 : chirpClient).call(References.createRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.playlists.rpc.LearningPathChirpService#createFromPlaylist
 */
export const CREATE_FROM_PLAYLIST_MUTATION_FIELD_NAME = 'com_hubspot_learning_center_playlists_rpc_LearningPathChirpService_createFromPlaylist';
export const CREATE_FROM_PLAYLIST_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_FROM_PLAYLIST_MUTATION_FIELD_NAME,
  args: ['name', 'description', 'thumbnailRectangleUrl', 'thumbnailSquareUrl', 'playlistId', 'internalName', 'visibility', 'difficulty', 'active', 'language'],
  fetcher(request, ctx) {
    var _ctx$customClient9;
    return ((_ctx$customClient9 = ctx.customClient) !== null && _ctx$customClient9 !== void 0 ? _ctx$customClient9 : chirpClient).call(References.createFromPlaylistRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.playlists.rpc.LearningPathChirpService#update
 */
export const UPDATE_MUTATION_FIELD_NAME = 'com_hubspot_learning_center_playlists_rpc_LearningPathChirpService_update';
export const UPDATE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_MUTATION_FIELD_NAME,
  args: ['playlistId', 'name', 'description', 'thumbnailSquareUrl', 'thumbnailRectangleUrl', 'internalName', 'visibility', 'difficulty', 'active', 'language', 'items', 'hiddenForOwner'],
  fetcher(request, ctx) {
    var _ctx$customClient10;
    return ((_ctx$customClient10 = ctx.customClient) !== null && _ctx$customClient10 !== void 0 ? _ctx$customClient10 : chirpClient).call(References.updateRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.playlists.rpc.LearningPathChirpService#delete
 */
export const DELETE_MUTATION_FIELD_NAME = 'com_hubspot_learning_center_playlists_rpc_LearningPathChirpService_delete';
export const DELETE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: DELETE_MUTATION_FIELD_NAME,
  args: ['playlistId'],
  fetcher(request, ctx) {
    var _ctx$customClient11;
    return ((_ctx$customClient11 = ctx.customClient) !== null && _ctx$customClient11 !== void 0 ? _ctx$customClient11 : chirpClient).call(References.deleteRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});